const dict: Record<string, string> = {
  // Nav
  dashboard: "Головна",
  catalog: "Каталог",
  cart: "Кошик",
  orders: "Замовлення",
  account: "Акаунт",
  invoices: "Рахунки",
  nav_main: "Робота",
  nav_account: "Акаунт",

  // Common
  search: "Пошук",
  search_products: "Пошук по артикулу, назві...",
  filter: "Фільтр",
  sort: "Сорт.",
  add_to_cart: "У кошик",
  in_cart: "У кошику",
  place_order: "Оформити замовлення",
  add_short: "Додати",
  add_more: "Додати ще",
  total: "Всього",
  subtotal: "Підсумок",
  discount: "Знижка",
  delivery: "Доставка",
  qty: "Кількість",
  qty_decrement: "Зменшити кількість",
  qty_increment: "Збільшити кількість",
  unit: "За одиницю",
  price: "Ціна",
  retail: "Роздріб",
  your_price: "Ваша ціна",
  saved: "Економія",
  sku: "Артикул",
  stock: "Склад",
  in_stock: "В наявності",
  low_stock: "Мало",
  out_of_stock: "Немає",
  create_order: "Створити замовлення",
  repeat_order: "Повторити замовлення",
  view_all: "Всі",
  items: "Позицій",
  items_word: "позицій",
  amount: "Сума",
  product: "Товар",
  status: "Статус",
  payment: "Оплата",
  paid: "Оплачено",
  unpaid: "Не оплачено",
  free: "Безкоштовно",
  optional: "необов'язково",
  clear: "Очистити",
  retry: "Повторити",
  repeat: "Повторити",
  invoice: "Інвойс",
  order: "Замовлення",
  date: "Дата",
  due: "Термін оплати",
  due_by: "до",
  primary: "Основна",
  primary_m: "Основний",
  yes: "Так",
  no: "Ні",
  all: "Усі",
  view: "Перегляд",
  admin: "Адмін",
  user: "Користувач",
  invite: "Запросити",
  added: "Додано:",
  category: "Категорія",

  // Status
  status_new: "Нове",
  status_processing: "В обробці",
  status_shipped: "Відправлено",
  status_delivered: "Доставлено",
  status_cancelled: "Скасовано",

  // Login
  login_title: "Вхід до B2B порталу",
  login_sub: "Увійдіть, щоб керувати замовленнями для вашого закладу.",
  email: "Email",
  password: "Пароль",
  show_password: "Показати пароль",
  hide_password: "Сховати пароль",
  forgot: "Забули пароль?",
  sign_in: "Увійти",
  or: "або",
  magic: "Увійти за посиланням",
  magic_link_send: "Надіслати посилання",
  magic_check_email: "Перевірте email",
  no_account: "Немає доступу?",
  request: "Запросити акаунт",
  wholesale_portal: "Оптовий портал",
  signing_in: "Вхід...",
  invalid_email: "Невірний email",
  check_inbox: "Перевірте пошту",
  magic_sent: "Ми надіслали посилання для входу на",
  magic_expire: "Посилання дійсне 15 хвилин.",
  back_to_password: "Назад до паролю",
  brand_panel_copy:
    "Замовляйте зерно, обладнання та аксесуари напряму від обсмажувальні з індивідуальними умовами, NET-14 та персональним менеджером.",
  partner_venues: "закладів-партнерів",
  on_market: "на ринку",
  payment_terms_label: "умови оплати",

  // Dashboard
  welcome: "Вітаємо",
  your_tier: "Ваш тариф",
  personal_manager: "Персональний менеджер",
  balance: "Баланс",
  recent_orders: "Останні замовлення",
  quick_actions: "Швидкі дії",
  today_date_long: "18 КВІТНЯ 2026 · СУБОТА",
  dash_sub_a: "Ваш баланс, замовлення та швидкі дії для ",
  dash_sub_b: ".",
  credit: "Кредит",
  tier_b_hint: "Індивідуальні ціни — 20% від роздрібу",
  saved_this_year: "Зекономлено цього року",
  across_word: "на",
  orders_word: "замовленнях",
  active_orders: "Активні замовлення",
  one_processing: "1 в обробці",
  send_message: "Надіслати повідомлення",
  whats_new: "Новинки",
  frequent_items: "Ваші постійні позиції",
  one_click_reorder: "Додати у кошик одним кліком",

  // Catalog
  categories: "Категорії",
  availability: "Наявність",
  origin: "Походження",
  weight: "Вага",
  cat_beans: "Кава в зернах",
  cat_ground: "Мелена / дріпи",
  cat_equipment: "Обладнання",
  cat_accessories: "Аксесуари",
  cat_training: "Навчання",
  view_grid: "Сітка",
  view_table: "Таблиця",
  wholesale_catalog: "Оптовий каталог",
  catalog_sub_a:
    " позицій · Ціни вказані з урахуванням ваших умов HoReCa — Tier B",
  any_availability: "Будь-яка наявність",
  featured: "За замовчуванням",
  price_low_high: "Ціна ↑",
  price_high_low: "Ціна ↓",
  alpha: "За алфавітом",
  all_items: "Усі товари",
  catalog_err: "Не вдалося завантажити каталог",
  catalog_err_sub: "Перевірте підключення та спробуйте ще раз.",
  nothing_found: "Нічого не знайдено",
  nothing_found_sub: "Спробуйте інші ключові слова або скиньте фільтри.",
  clear_filters: "Скинути фільтри",
  restocking: "Очікується",

  // Cart
  your_cart: "Ваш кошик",
  empty_cart: "Кошик порожній",
  empty_cart_sub: "Додайте товари з каталогу, щоб почати замовлення.",
  go_to_catalog: "До каталогу",
  order_summary: "Підсумок замовлення",
  delivery_address: "Адреса доставки",
  payment_method: "Спосіб оплати",
  payment_terms: "Оплата після доставки (NET-14)",
  delivery_method: "Спосіб доставки",
  choose_one: "Оберіть один варіант",
  odesa_logist: "Власний логіст в Одесі",
  odesa_logist_meta: "1–2 робочих дні · по місту",
  odesa_logist_short: "Логіст Одеса",
  np_short: "Нова Пошта",
  min_prefix: "мін.",
  available_from: "Доступно від",
  shortfall_a: "Додайте товарів ще на ",
  shortfall_b:
    ", щоб скористатись власним логістом — або скористайтесь Новою Поштою нижче.",
  add_items: "Додати товари",
  switch_to_np: "Перейти на Нову Пошту",
  np_branch: "Нова Пошта · відділення",
  np_meta: "1–3 робочі дні · по всій Україні",
  city: "Місто",
  branch_num: "№ Відділення",
  order_note: "Коментар до замовлення",
  order_note_ph: "Побажання щодо доставки, маркування тощо...",
  delivery_via_odesa: "Доставка · Логіст Одеса",
  delivery_via_np: "Доставка · Нова Пошта",
  incl_vat: "У т.ч. ПДВ 20% ·",
  payment_status_unpaid: "Статус оплати: Не оплачено",
  payment_status_unpaid_sub:
    "Замовлення створюється без миттєвої оплати. Менеджер надішле рахунок.",
  net14_note: "Без миттєвої оплати · NET-14",
  order_copied: "Замовлення відтворено у кошику",
  order_created_a: "Замовлення створено ·",
  order_created_b: "· Не оплачено",
  order_error: "Не вдалося оформити замовлення. Спробуйте ще раз.",

  // Orders
  order_history: "Історія замовлень",
  order_num: "№ замовлення",
  ordered_on: "Дата",
  orders_total_suffix: " замовлень загалом · Натисніть, щоб переглянути деталі",
  search_by_num: "Пошук за номером...",
  no_orders: "Замовлень немає",
  fulfilment: "Доставка",
  line_items: "Позиції",
  unpaid_awaiting: "Не оплачено · очікує інвойс",
  payment_colon: "Оплата:",
  download_invoice: "Завантажити інвойс",
  invoice_sent: "Інвойс надіслано на email",

  // Account
  company: "Компанія",
  addresses: "Адреси",
  payment_methods: "Оплата",
  account_settings: "Акаунт і налаштування",
  account_sub: "Керуйте компанією, адресами доставки та способами оплати.",
  team: "Команда",
  preferences: "Налаштування",
  company_details: "Інформація про компанію",
  save_changes: "Зберегти",
  legal_name: "Юридична назва",
  brand_name: "Торгова марка",
  tax_id: "ЄДРПОУ",
  vat_registered: "Платник ПДВ",
  billing_email: "Email для рахунків",
  phone: "Телефон",
  your_manager: "Ваш менеджер",
  payment_terms_row: "Умови оплати",
  customer_since: "Клієнт з",
  upgrade_tier:
    "Підвищення до Tier A доступне після 500 000 ₴ на рік — лишилось 84 000 ₴.",
  credit_line: "Кредитний ліміт",
  available_word: "доступно",
  used: "Використано",
  limit: "Ліміт",
  delivery_addresses: "Адреси доставки",
  add_address: "Додати адресу",
  payment_methods_title: "Способи оплати",
  add_method: "Додати спосіб",
  net14_apply:
    "Умови оплати NET-14 автоматично застосовуються до всіх замовлень понад 5 000 ₴.",
  owner_role: "Власник",
  procurement: "Менеджер закупівель",
  head_barista: "Головний бариста",
  team_members: "Учасники команди",
  team_role: "Права",
  role_orders: "Замовлення",
  notifications: "Сповіщення",
  notif_status: "Зміни статусу замовлення",
  notif_restock: "Повернення товару на склад",
  notif_new_arrivals: "Нові позиції у каталозі",
  notif_promo: "Акції та сезонні пропозиції",

  // Invoices
  invoices_title: "Рахунки та документи",
  invoices_sub: "Всі податкові накладні, акти та інвойси.",
  export_csv: "Експорт CSV",

  // Shell
  menu: "Меню",
  help: "Допомога",
  search_placeholder: "Пошук по всьому...",
  close: "Закрити",
  guest: "Гість",
  logout: "Вийти",
  remove: "Видалити",

  // Not found
  not_found_title: "Сторінку не знайдено",
  not_found_subtitle: "Можливо, посилання застаріле або сторінку перенесено.",
  go_to_dashboard: "На головну",

  // Misc
  today: "сьогодні",
  yesterday: "вчора",
  days_ago: "дн. тому",

  // Register
  r_eyebrow: "Оптовий портал · Реєстрація",
  r_title: "Запросити доступ",
  r_sub:
    "Розкажіть про свій заклад — менеджер підготує індивідуальну пропозицію за 1 робочий день.",
  r_s1: "Компанія",
  r_s2: "Заклад",
  r_s3: "Контакти",
  r_step: "Крок",
  r_of: "з",
  r_required_field: "Заповніть обов'язкові поля",
  r_company_legal: "Юридична назва",
  r_company_hint: "ТОВ / ФОП / ПП",
  r_edrpou: "ЄДРПОУ / ІПН",
  r_vat: "Платник ПДВ",
  r_yes: "Так",
  r_no: "Ні",
  r_brand_name: "Назва закладу (бренд)",
  r_brand_hint: "Публічна назва, яку бачить клієнт",
  r_venue_type: "Тип закладу",
  r_cafe: "Кав'ярня",
  r_restaurant: "Ресторан",
  r_hotel: "Готель",
  r_office: "Офіс / корпорація",
  r_reseller: "Реселер",
  r_other: "Інше",
  r_venues: "Кількість точок",
  r_volume: "Приблизне споживання на місяць",
  r_v1: "До 20 кг",
  r_v2: "20–50 кг",
  r_v3: "50–150 кг",
  r_v4: "Понад 150 кг",
  r_name_full: "ПІБ контактної особи",
  r_role: "Ваша роль",
  r_owner: "Власник",
  r_buyer: "Закупівельник",
  r_barista: "Головний бариста",
  r_manager: "Менеджер",
  r_email: "Робочий email",
  r_phone: "Телефон",
  r_note: "Коментар для менеджера",
  r_note_ph: "Що ви вже замовляєте, які бренди любите, особливі потреби...",
  r_accept_tos: "Погоджуюсь з умовами співпраці та обробкою даних",
  r_accept_tos_required: "Потрібно погодитись з умовами",
  r_continue: "Далі",
  r_back: "Назад",
  r_submit: "Надіслати заявку",
  r_submit_error: "Не вдалося надіслати заявку. Спробуйте ще раз.",
  r_have_account: "Вже маєте доступ?",
  r_sign_in: "Увійти",
  r_sent_title: "Заявку отримано!",
  r_sent_sub:
    "Анна Литвин, ваш майбутній менеджер, зв'яжеться з вами протягом 24 годин за номером",
  r_what_next: "Що далі",
  r_n1: "Менеджер перевірить дані та узгодить індивідуальні ціни HoReCa",
  r_n2: "Ви отримаєте email з логіном і тимчасовим паролем",
  r_n3: "Перше замовлення — зі знижкою −5% на весь чек",
  r_back_to_site: "На сайт foundation.ua",
  r_why_title: "Що отримуєте як B2B-партнер",
  r_w1_t: "Індивідуальні ціни",
  r_w1_s: "HoReCa-тарифи від −15% до −25% від роздрібу",
  r_w2_t: "NET-14 оплата",
  r_w2_s: "Відтермінована оплата для постійних клієнтів",
  r_w3_t: "Персональний менеджер",
  r_w3_s: "Прямий контакт без черг",
  r_w4_t: "Пріоритетна доставка",
  r_w4_s: "Наступного дня по Одесі, 2 дні по Україні",
  r_for_venues: "Для закладів та реселерів",
  r_hero_a: "Станьте",
  r_hero_b: "партнером",
  r_hero_c: "Foundation.",
  r_bottom_copy:
    "Вже 240+ закладів по Україні замовляють зерно, обладнання та аксесуари напряму з обсмажувальні в Одесі.",
};

export default dict;
